import Vue from 'vue';
import * as types from './mutation-types';

export function setLoading(context, status) {
  context.commit(types.SET_LOADING, status);
}

export async function getEvents(context, filters) {
  const { data } = await Vue.axios.post('/person.get-contact', {
    ...filters,
    isNewVersion: true,
  });

  if (!Array.isArray(data)) {
    context.commit(types.SET_EVENTS, []);
    return;
  }

  context.commit(types.SET_EVENTS, data);
}

export function setMenu(context, menus) {
  context.commit(types.SET_MENUS, menus);
}

export function setDefaultRoute(context, route = {}) {
  context.commit(types.SET_DEFAULT_ROUTER, route);
}

export async function getMenus(context) {
  const { data: menus } = await Vue.axios.postWithCache('application.get-menu');

  if (!Array.isArray(menus)) {
    context.commit(types.SET_MENUS, []);
    return;
  }

  context.commit(types.SET_MENUS, menus);
}

export function handleOpenMenu(context, menu) {
  context.commit(types.SET_OPEN_MENU, context.getters.openMenu === menu ? null : menu);
}

export function handleShowNotifications(context, showNotifications) {
  context.commit(types.SET_SHOW_NOTIFICATIONS, showNotifications);
}

export function handleSelectMenu(context, selected = {}) {
  const { menu, submenu, v2 } = selected;

  context.commit(types.SET_DEFAULT_ROUTER, {
    menu,
    menuMobile: menu,
    submenu,
  });

  context.commit(types.SET_TOGGLE_MENU, false);
  context.commit(types.SET_OPEN_MENU, null);

  if (submenu && !v2) {
    return `/#/${menu}/${submenu}/`;
  }

  return `/${menu}/${submenu}`;
}

export function handleToggleMenu(context) {
  context.commit(types.SET_DEFAULT_ROUTER, {
    ...context.getters.defaultRoute.menu,
    menuMobile: null,
  });

  context.commit(types.SET_TOGGLE_MENU, !context.getters.toggleMenu);
}

export function getConfigEmissor() {
  const configurations = window.localStorage.getItem('configurationEmissor') || '{}';
  const parse = JSON.parse(configurations);
  return {
    decimalPrice: parse?.decimalPrice || 2,
    decimalQuantity: parse?.decimalQuantity || 2,
  };
}

export async function setUserCollection(context) {
  if (context.state.userCollection && context.state.userCollection.length > 0) {
    return;
  }

  const { data } = await Vue.axios.post('application.get-users-client-no-admin', {
    active: true,
    isClient: true,
  });

  const collection = !Array.isArray(data) ? [] : data;

  context.commit(types.SET_USER_COLLECTION, collection);
}
